import { render } from "./MetadataActions.vue?vue&type=template&id=3e9433fd&scoped=true"
import script from "./MetadataActions.vue?vue&type=script&lang=js"
export * from "./MetadataActions.vue?vue&type=script&lang=js"

import "./MetadataActions.vue?vue&type=style&index=0&id=3e9433fd&scoped=true&lang=css"

import exportComponent from "/builds/arkindex/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e9433fd"]])

export default __exports__